window.LN = window.LN || {};
LN.App = {};
LN.Core = {};
LN.Config = {};
LN.Model = {};
LN.Service = {};
LN.Helper = {};
LN.LocalStorage = {};
LN.Controller = {};
LN.Handler = {};
LN.Message = {};
LN.Message.Analytics = {};
LN.Analytics = {};
LN.Hotjar = {};
LN.CustomDimension = {};
// Quitar cuando se defina el logger en Login.
window.logger = null;



if (!Object.values) {
    Object.values = function (object) {
        return Object.keys(object).map(key => object[key]);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/core.js